export var TransactionType;
(function(TransactionType) {
  TransactionType["TO_RECEIVER"] = "to_receiver";
  TransactionType["TO_SELF"] = "to_self";
})(TransactionType || (TransactionType = {}));
export var AccAssetType;
(function(AccAssetType) {
  AccAssetType["SHEET"] = "acs_sheet";
  AccAssetType["FILES"] = "acs_document";
  AccAssetType["FOLDER"] = "acs_folder";
})(AccAssetType || (AccAssetType = {}));
export var ReceivedTransactionStatus;
(function(ReceivedTransactionStatus) {
  ReceivedTransactionStatus["RECEIVING"] = "receiving";
  ReceivedTransactionStatus["RECEIVED"] = "received";
  ReceivedTransactionStatus["FAILED"] = "failed";
})(ReceivedTransactionStatus || (ReceivedTransactionStatus = {}));
export var SentTransactionStatus;
(function(SentTransactionStatus) {
  SentTransactionStatus["SENT"] = "sent";
  SentTransactionStatus["ACCEPTED"] = "accepted";
})(SentTransactionStatus || (SentTransactionStatus = {}));
export var BridgeStatus;
(function(BridgeStatus) {
  BridgeStatus["ACTIVE"] = "ACTIVE";
  BridgeStatus["INACTIVE"] = "INACTIVE";
})(BridgeStatus || (BridgeStatus = {}));
export var QueryAutomationsFields;
(function(QueryAutomationsFields) {
  QueryAutomationsFields["AUTOMATION_UID"] = "automation_uid";
  QueryAutomationsFields["NAME"] = "name";
  QueryAutomationsFields["SOURCE_KEY_UID"] = "source_key_uid";
  QueryAutomationsFields["ASSET_TYPE"] = "asset_type";
  QueryAutomationsFields["SOURCE_PROJECT_UID"] = "source_project_uid";
  QueryAutomationsFields["SENDER_USER_OID"] = "sender_user_oid";
  QueryAutomationsFields["HISTORY_UID"] = "history_uid";
  QueryAutomationsFields["TARGET_KEY_UID"] = "target_key_uid";
  QueryAutomationsFields["TARGET_PROJECT_UID"] = "target_project_uid";
  QueryAutomationsFields["SOURCE_DEACTIVATED_BY"] = "source_deactivated_by";
  QueryAutomationsFields["TARGET_DEACTIVATED_BY"] = "target_deactivated_by";
  QueryAutomationsFields["TARGET_COLLECTION_UID"] = "target_collection_uid";
  QueryAutomationsFields["SOURCE_COLLECTION_UID"] = "source_collection_uid";
  QueryAutomationsFields["TARGET_COLLECTION_NAME"] = "target_collection_name";
  QueryAutomationsFields["SOURCE_COLLECTION_NAME"] = "source_collection_name";
})(QueryAutomationsFields || (QueryAutomationsFields = {}));
export var BridgeRequestStatus;
(function(BridgeRequestStatus) {
  BridgeRequestStatus["PENDING"] = "PENDING";
  BridgeRequestStatus["ACCEPTED"] = "ACCEPTED";
  BridgeRequestStatus["WITHDRAWN"] = "WITHDRAWN";
})(BridgeRequestStatus || (BridgeRequestStatus = {}));
